"use client";
import Image from "next/image";
import { useScreen } from "@/hooks/useScreen";

interface PromiseIconProps {
  src: string;
  alt: string;
  text: string;
}

function PromiseIcon({ src, alt, text }: PromiseIconProps) {
  const { isMobile } = useScreen();

  if (isMobile) {
    return (
      <div className="flex items-center gap-8 mb-4 w-full max-w-[280px] mx-auto">
        <div className="w-8 flex-shrink-0 ">
          <Image
            src={src}
            alt={alt}
            width={60}
            height={60}
            className="w-8 h-8"
          />
        </div>
        <p className="text-[#920000] font-['Ainslie_Sans'] text-[18px] font-semibold">{text.replace(/<br\/>/g, ' ')}</p>
      </div>
    );
  }

  return (
    <div className="text-center w-44 py-4">
      <Image
        src={src}
        alt={alt}
        width={60}
        height={60}
        className="mx-auto mb-3 w-[70px] h-[70px]"
      />
      <p
        className="promise-text-desktop text-[#920000] font-['Ainslie_Sans'] leading-[1.2] text-[26px] font-semibold"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

const promiseIcons = [
  {
    src: "/images/icons svg/Backed by experts.svg",
    alt: "Backed by experts",
    text: "Backed<br/>by experts",
  },
  {
    src: "/images/icons svg/Pharma-grade ingredients.svg",
    alt: "Pharma-grade ingredients",
    text: "Pharma-grade<br/>ingredients",
  },
  {
    src: "/images/icons svg/Clinically proven.svg",
    alt: "Clinically proven",
    text: "Clinically<br/>proven",
  },
  {
    src: "/images/icons svg/Controlled craving relief.svg",
    alt: "Controlled craving relief",
    text: "Controlled<br/>craving relief",
  },
  // {
  //   src: "/images/icons svg/2x More Effective.svg",
  //   alt: "2x more effective",
  //   text: "2x more<br/>effective",
  // },
];

export default function PromiseIconsSection() {
    const { isMobile } = useScreen();
  
  return (
    <section className={`py-8 md:py-8 ${isMobile ? 'bg-[#f8f6f9]  ' : 'bg-[#f8f6f9]'}`}>
      <div className="container mx-auto px-8 max-w-[1400px]">
        <div className={isMobile ? "flex flex-col items-center gap-3" : "flex flex-wrap justify-center gap-4 md:gap-8 lg:gap-20 xl:flex-nowrap"}>
          {promiseIcons.map((icon) => (
            <PromiseIcon key={icon.alt} {...icon} />
          ))}
        </div>
      </div>
    </section>
  );
}